export enum USTimeZone {
  CENTRAL = 'America/Chicago',
  EASTERN = 'America/New_York',
  MOUNTAIN = 'America/Denver',
  PACIFIC = 'America/Los_Angeles',
}

export const TIMEZONES_LIST = [
  {
    id: 'US/Central',
    name: 'Central Time Zone',
  },
  {
    id: 'US/Eastern',
    name: 'Eastern Time Zone',
  },
  {
    id: 'US/Mountain',
    name: 'Mountain Time Zone',
  },
  {
    id: 'US/Pacific',
    name: 'Pacific Time Zone',
  },
];
